<template>
  <div>
    <home-banner></home-banner>
    <home-strength-intro
      :imgurl=price
      :isSecond=false
      slogan="权威的指导价格"
      description="汇总全国重要口岸实时价格，提供行情分析，轻松判断价格走势。"></home-strength-intro>
    <home-strength-intro
      :imgurl=quality
      :isSecond=true
      slogan="专业的质量保障"
      description="布局重要木材口岸甄选优质商家，提供优质、真实的货源。"></home-strength-intro>
    <home-strength-intro
      :imgurl=pay
      :isSecond=false
      slogan="安全的三方支付"
      description="木材码头不触碰用户的资金，资金流转在第三方支付平台及银行体系内完成。"></home-strength-intro>
    <home-strength-intro
      :imgurl=service
      :isSecond=true
      slogan="便捷的增值服务"
      description="以供货、销售、仓储、物流、货检、验收、结算等环节提供专业化服务。"></home-strength-intro>
    <home-strength-intro
      :imgurl=info
      :isSecond=false
      slogan="广泛的资源信息"
      description="通过大数据整合行业资讯、库存信息、政策信息，提供精确分析。"></home-strength-intro>
    <home-strength-intro
      :imgurl=corp
      :isSecond=true
      slogan="共赢的合作理念"
      description="以共赢为点，打造木材产业合作、开放的综合服务平台。"></home-strength-intro>
  </div>
</template>

<script>
  import HomeStrengthIntro from './HomeStrengthIntro.vue'
  import HomeBanner from './HomeBanner'
  export default {
    name: 'HomeContent',
    components: {
      HomeBanner, HomeStrengthIntro
    },
    data () {
      return {
        price: '/static/img/strength_intro/price.png',
        quality: '/static/img/strength_intro/quality.png',
        pay: '/static/img/strength_intro/pay.png',
        service: '/static/img/strength_intro/service.png',
        info: '/static/img/strength_intro/info.png',
        corp: '/static/img/strength_intro/corp.png'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// HomeContent.vue?679e824a